var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(((_vm.finding.vulnerable_type) + "-vulnerability"),{tag:"component",attrs:{"vulnerability":_vm.finding.vulnerable}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }